import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { InfoLabel } from '../InfoLabel/InfoLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export const TeaserLabel = ({
  label,
  ...rest
}) => /*#__PURE__*/_jsx(Fragment, {
  children: label && /*#__PURE__*/_jsx(Layout, {
    ...rest,
    children: /*#__PURE__*/_jsx(InfoLabel, {
      type: label.type,
      text: label.text,
      "aria-hidden": "true"
    })
  })
});
const Layout = styled.div.withConfig({
  displayName: "TeaserLabel__Layout",
  componentId: "sc-1nnhnqv-0"
})(["display:inline-flex;justify-content:center;margin-left:8px;margin-top:8px;"]);